import React from "react";
import "./About.css"

const About = () => {
  return (
    <div className="about">
      My name is Tay, and I'm a software developer currently based in Jacksonville, Florida. I'm passionate about the way design shapes people’s reactions to media and love learning new ways to simplify and streamline code. When I'm not programming you can find me roller skating, gaming, or hanging out with my cats.
    </div>
  )
}

export default About